import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717a54de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }

import { ArmyDTO } from "@/interfaces/Army";
import { RequesListaDTO } from "@/interfaces/Lista";
import { appsettings } from "@/settings/appsettings";
import { uploadImageToCloudinary } from "@/services/CloudinaryService";
import { ref, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEnviarLista',
  props: {
    isVisible: { type: Boolean },
    hasLista: { type: Boolean },
    idInscripcion: {},
    idUsuario: {},
    nick: {}
  },
  emits: ["update:isVisible", "enviarLista", "modificarLista"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Computed reactividad con v-model
const visible = computed({
  get: () => props.isVisible,
  set: (val: boolean) => emit("update:isVisible", val),
});

const isLoading = ref(false);
const imageBase64 = ref<string | null>(null);

const ejercitoSelected = ref<ArmyDTO>();
const listadoEjercitos = ref<ArmyDTO[]>([]);
const loadingEjercitos = ref<boolean>(false);

const cambiarImagen = () => {
  imageBase64.value = null;
};

const onImageSelected = async (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    isLoading.value = true;
    try {
      imageBase64.value = await uploadImageToCloudinary(file);
    } catch (error) {
      console.error("Error al subir la imagen:", error);
    } finally {
      isLoading.value = false;
    }
  }
};

const rules = {
  required: (value: string | null) => !!value || "El ejército es obligatorio.",
};

const loadEjercitos = async () => {
  isLoading.value = true;
  loadingEjercitos.value = true;

  listadoEjercitos.value = appsettings.armies;

  isLoading.value = false;
  loadingEjercitos.value = false;
};

const enviarLista = () => {
  if (imageBase64.value && ejercitoSelected.value) {
    const newLista: RequesListaDTO = {
      listaData: imageBase64.value,
      ejercito: ejercitoSelected.value,
      idUsuario: props.idUsuario,
      nick: "",
    };

    if (props.hasLista) {
      emit("modificarLista", newLista);
    } else {
      emit("enviarLista", newLista);
    }
    close();
  }
};

const close = () => {
  emit("update:isVisible", false);
};

// Reset de datos al abrir modal (opcional)
watch(visible, (newVal) => {
  if (newVal) {
    ejercitoSelected.value = undefined;
    imageBase64.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline" }, {
            default: _withCtx(() => [
              _createTextVNode("Enviar lista")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_combobox, {
                modelValue: ejercitoSelected.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ejercitoSelected).value = $event)),
                items: listadoEjercitos.value,
                "item-title": "name",
                label: "¿Cuál es tu ejército?",
                onClick: loadEjercitos,
                rules: [rules.required],
                required: ""
              }, null, 8, ["modelValue", "items", "rules"]),
              (loadingEjercitos.value)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    class: "progress-linear-margin"
                  }))
                : _createCommentVNode("", true),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (imageBase64.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("img", {
                            src: imageBase64.value,
                            alt: "Lista cargada",
                            class: "uploaded-image"
                          }, null, 8, _hoisted_4)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_file_input, {
                            label: "Selecciona una imagen",
                            onChange: onImageSelected,
                            accept: "image/*"
                          })
                        ]))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { style: {"display":"flex","justify-content":"flex-end"} }, {
            default: _withCtx(() => [
              (imageBase64.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "primary",
                      onClick: cambiarImagen
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cambiar")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "primary",
                      onClick: enviarLista,
                      disabled: !imageBase64.value || !ejercitoSelected.value,
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Enviar ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                variant: "tonal",
                color: "secondary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})